import { createTheme } from '@mui/material';

export const theme = createTheme({
  typography: {
    fontFamily: ['Space Grotesk', 'Helvetica', 'Arial', 'serif'].join(', '),
  },
});
